import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { REDIRECT_CONSTANTS } from 'constants/constants';

const { REDIRECT_URL, HOME_ROUTE } = REDIRECT_CONSTANTS;

class PublicRoute extends PureComponent {
  static propTypes = {
    loggedIn: PropTypes.bool.isRequired,
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  };

  render() {
    const { loggedIn, component: Component, ...other } = this.props;
    const redirectURL = localStorage.getItem(REDIRECT_URL);

    return (
      <Route
        {...other}
        render={props => {
          if (loggedIn) {
            return (
              <Redirect
                to={{
                  pathname: HOME_ROUTE,
                }}
              />
            );
          }
          if (redirectURL === HOME_ROUTE) {
            localStorage.removeItem(REDIRECT_URL);
          }
          return <Component {...props} />;
        }}
      />
    );
  }
}

const selector = ({ auth: { loggedIn } }) => ({
  loggedIn,
});

export default withRouter(connect(selector)(PublicRoute));
